import { Injectable } from '@angular/core';
import { ErrorHandlerService } from '@examdojo/error-handling';
import { finalize, map, tap } from 'rxjs';
import { ClassInsightsHttpService } from './class-insights-http.service';
import { mapClassInsightsRpcRowToStoreModel } from './class-insights.model';
import { ClassInsightsStore } from './class-insights.store';

@Injectable({ providedIn: 'root' })
export class ClassInsightsService {
  constructor(
    private readonly store: ClassInsightsStore,
    private readonly http: ClassInsightsHttpService,
    private readonly errorHandler: ErrorHandlerService,
  ) {}

  init(classId: string) {
    this.store.setLoading(true);

    return this.http.fetchByClassId(classId).pipe(
      this.errorHandler.setHttpErrorMetadata({ entity: 'class_insights', action: 'fetch' }),
      map((row) => mapClassInsightsRpcRowToStoreModel(row, classId)),
      tap((insights) => {
        this.store.upsert(insights.classId, insights);
        this.store.setActive(insights.classId);
      }),
      finalize(() => this.store.setLoading(false)),
    );
  }
}
